import React, { useEffect, useState } from "react";
import { FixedHeaderContainer } from "./component/styled/header";
import Logo from "../header/component/common/logo";
import { useNavigate } from "react-router";
import SearchForm from "./component/common/searchForm";
import Search from "./component/common/search";
import Gnb from "./component/common/gnb";
import Category from "./component/common/category";

const FixedHeader = ({ homepageInfo, theme, isMatch, menus, url }) => {
  const navigate = useNavigate();

  const [logo, setLogo] = useState("");
  const [toggleSearch, setToggleSearch] = useState(false);

  const handleHome = () => {
    navigate(`/shop${url ? `/${url}` : ""}`);
  };

  useEffect(() => {
    if (homepageInfo) {
      setLogo(imgHandler(homepageInfo.logoImage));
    }
  }, [homepageInfo]);

  return (
    <FixedHeaderContainer className={`theme-${theme}`}>
      <div className="inner">
        <div>
          <Category isFixed={true} />
          <Logo
            logo={logo}
            handleHome={handleHome}
            homepageInfo={homepageInfo}
            cmpnyNm={homepageInfo?.cmpnyNm}
            theme={theme}
            isMatch={isMatch}
          />
        </div>
        <Search setToggleSearch={setToggleSearch} />
        <Gnb menus={menus} url={url} theme={theme} isMatch={isMatch} homepageInfo={homepageInfo} />
      </div>
      {["0", "2"].includes(String(theme)) && (
        <SearchForm toggleSearch={toggleSearch} setToggleSearch={setToggleSearch} />
      )}
    </FixedHeaderContainer>
  );
};

export default FixedHeader;
